module.exports = __webpack_public_path__ + "img/fw_workflow_4.d8763be1.png";